import { FetchState, SortOrder, EmployeeSearchSortOption } from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import * as BankService from "@/shared/api/bankService";
import {
    EmployeeSearchResults,
    EmployeeSearchState,
    EmployeeSearchTerm
} from "@/employer/types";
import _ from "lodash";
import { defineStore } from "pinia";

export const initialState: EmployeeSearchState = {
    searchEmployeeState: FetchState.Uninitialized,
    searchResult: null,
    searchTerm: {
        firstName: "",
        lastName: "",
        login: "",
        email: "",
        ssn4: "",
        ssn: "",
        cognitoUsername: "",
        loginName: "",
        accountNumber: "",
        investmentAccountNumber: "",
        employerEmployeeId: "",
        externalEmployerId: "",
        sortOrder: SortOrder.None,
        sortOption: EmployeeSearchSortOption.Relevance
    },
    selectedPartnerId: 0,
    selectedPageNumber: 1
};

export const useEmployeeSearchStore = defineStore("employeeSearch", {
    state: (): EmployeeSearchState => (_.cloneDeep(initialState)),
    getters: {
        hasResults: state => state.searchResult && state.searchResult.numberFound > 0,
        isInitialized: state => state.searchEmployeeState !== FetchState.Uninitialized,
        isLoading: state => state.searchEmployeeState === FetchState.Loading,
    },
    actions: {
        setEmployeeSearchLoading () {
            this.searchEmployeeState = FetchState.Loading;
        },
        setEmployeeSearchResult (result: EmployeeSearchResults) {
            this.searchResult = result;
            this.searchEmployeeState = FetchState.Loaded;
        },
        clearEmployeeSearchResult () {
            this.searchResult = null;
            this.searchEmployeeState = FetchState.Uninitialized;
            this.selectedPartnerId = 0;
            this.searchTerm = null;
            this.selectedPageNumber = 1;
        },
        setSelectedPartnerId (partnerId: number) {
            this.selectedPartnerId = partnerId;
        },
        setSearchTerm (searchTerm: EmployeeSearchTerm) {
            this.searchTerm = searchTerm;
        },
        setSelectedPageNumber (pageNumber: number) {
            this.selectedPageNumber = pageNumber;
        },
        getEmployeeSearchResults (arg: {
            partnerId: number,
            searchTerms: EmployeeSearchTerm,
            pageNumber: number,
            pageSize: number
        }) {
            this.setEmployeeSearchLoading();
            this.setSelectedPartnerId(arg.partnerId);
            this.setSearchTerm(arg.searchTerms);
            this.setSelectedPageNumber(arg.pageNumber);

            if (arg.partnerId) {
                return UserService.getEmployeeSearchResults(arg.partnerId, arg.searchTerms, arg.pageNumber, arg.pageSize)
                    .then(userResponse => {
                        this.setEmployeeSearchResult(userResponse.data);
                    });
            }

            return UserService.getAdminParticipantSearchResults(arg.searchTerms, arg.pageNumber, arg.pageSize)
                .then(userResponse => {
                    this.setEmployeeSearchResult(userResponse.data);
                });
        },
    }
});